<script setup lang="ts">

import OnboardingMethodsConfigForm from "@/pages/Settings/AppConfigurationPage/components/OnboardingMethodsConfigForm.vue";
import ConsentsConfigForm from "@/pages/Settings/AppConfigurationPage/components/ConsentsConfigForm.vue";
import InitialProfileConfigForm from "@/pages/Settings/AppConfigurationPage/components/InitialProfileConfigForm.vue";
import CountriesConfigForm from "@/pages/Settings/AppConfigurationPage/components/CountriesConfigForm.vue";
import PrivacyAndTermsConfigForm from "@/pages/Settings/AppConfigurationPage/components/PrivacyAndTermsConfigForm.vue";
import DefaultAccountSettings from "@/pages/Settings/AppConfigurationPage/components/DefaultAccountSettings.vue";
import TenantSettingsConfigForm from "@/pages/Settings/AppConfigurationPage/components/TenantSettingsConfigForm.vue";
</script>

<template>

  <div class="mb-6">
    <countries-config-form />
  </div>

  <div class="mb-6">
    <default-account-settings/>
  </div>

  <div class="mb-6">
    <onboarding-methods-config-form/>
  </div>

  <div class="mb-6">
    <tenant-settings-config-form />
  </div>

  <div class="mb-6">
    <consents-config-form/>
  </div>

  <div class="mb-6">
    <privacy-and-terms-config-form />
  </div>

  <initial-profile-config-form/>
</template>

<style scoped>

</style>
